enum TriggerTargetType {
	DeviceTarget = 'DeviceTarget',
	GroupTarget = 'GroupTarget',
}

export default TriggerTargetType;
